export default {
  descriptionCostPerFlyer: { color: 'red', marginTop: 5, fontSize: 12 },
}
